import { render, staticRenderFns } from "./FU1.vue?vue&type=template&id=4c1d212f&lang=pug&"
import script from "./FU1.vue?vue&type=script&lang=ts&"
export * from "./FU1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports